import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import { useLanguage } from "../contexts/LanguageContext";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { language, toggleLanguage } = useLanguage();

  // Navbar content based on language
  const navContent = {
    home: {
      english: "Home",
      tamil: "முகப்பு"
    },
    about: {
      english: "About Us",
      tamil: "எங்களை பற்றி"
    },
    mission: {
      english: "Mission & Vision",
      tamil: "குறிக்கோள் & பார்வை"
    },
    event: {
      english: "Events Gallery",
      tamil: "நிகழ்வுகள் தொகுப்பு"
    },
    contact: {
      english: "Contact",
      tamil: "தொடர்பு"
    },
    joinParty: {
      english: "Join Party",
      tamil: "கட்சியில் சேருங்கள்"
    },
    menu: {
      english: "Menu",
      tamil: "பட்டி"
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* LOGO */}
        <div className="logo-container" onClick={() => navigate("/")}>
          <img src="/assets/sudha-bjp/bjp.png" alt="Logo" />
        </div>

        {/* DESKTOP NAV */}
        <div className="nav-links desktop-nav">
          <NavLink to="/" end>
            {navContent.home[language]}
          </NavLink>
          <NavLink to="/About">
            {navContent.about[language]}
          </NavLink>
          <NavLink to="/Mission-vission">
            {navContent.mission[language]}
          </NavLink>
          <NavLink to="/Events-gallery">
            {navContent.event[language]}
          </NavLink>
          <NavLink to="/Contact">
            {navContent.contact[language]}
          </NavLink>

          <NavLink to="/Contact">
            <span className="highlight">
              {navContent.joinParty[language]}
            </span>
          </NavLink>
        </div>
        <div className="teamtog">

          {/* Language Toggle Button */}
          <button
            className="language-toggle"
            onClick={toggleLanguage}
            title={language === 'tamil' ? 'Switch to English' : 'தமிழுக்கு மாற்று'}
          >
            {language === 'tamil' ? 'English' : 'தமிழ்'}
          </button>

          {/* MOBILE TOGGLE */}
          <button
            className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
            onClick={() => setIsMenuOpen(true)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* OVERLAY */}
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={() => setIsMenuOpen(false)}
      ></div>

      {/* MOBILE NAV */}
      <div className={`mobile-nav ${isMenuOpen ? "active" : ""}`}>
        <div className="mobile-nav-header">
          <h3>{navContent.menu[language]}</h3>
          <button className="close-menu" onClick={() => setIsMenuOpen(false)}>
            &times;
          </button>
        </div>

        <div className="mobile-nav-links">
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.home[language]}
          </NavLink>

          <NavLink
            to="/About"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.about[language]}
          </NavLink>

          <NavLink
            to="/Mission-vission"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.mission[language]}
          </NavLink>

          <NavLink
            to="/Events-gallery"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.event[language]}
          </NavLink>

          <NavLink
            to="/Contact"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.contact[language]}
          </NavLink>

          {/* Language Toggle in Mobile Menu */}
          <button
            className="language-toggle mobile-language-toggle"
            onClick={() => {
              toggleLanguage();
              setIsMenuOpen(false);
            }}
          >
            {language === 'tamil' ? 'Switch to English' : 'தமிழுக்கு மாற்று'}
          </button>

          <NavLink
            to="/Contact"
            className={({ isActive }) =>
              isActive ? "highlight active" : "highlight"
            }
            onClick={() => setIsMenuOpen(false)}
          >
            {navContent.joinParty[language]}
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;